import { render, staticRenderFns } from "./MdmInfiniteScroll.vue?vue&type=template&id=96885688&scoped=true&name=mdm-infinite-scroll&"
import script from "./MdmInfiniteScroll.vue?vue&type=script&lang=js&"
export * from "./MdmInfiniteScroll.vue?vue&type=script&lang=js&"
import style0 from "./MdmInfiniteScroll.vue?vue&type=style&index=0&id=96885688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96885688",
  null
  
)

export default component.exports